export interface OverlayViewSafe extends google.maps.OverlayView{}

function extend(type1: any, type2: any): void {
    for(let property in type2.prototype){
        type1.prototype[property] = type2.prototype[property];
    }
}

export class OverlayViewSafe {
    constructor(){
        extend(OverlayViewSafe, google.maps.OverlayView);
    }
}